export const getUsersRoute = (homeId: string) => `/${homeId}/users`
